import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import "./AgriCloudStack.css";
import AgriCloudStackBenefits from "./AgriCloudStackBenefits";
import AgriCloudStackFeatures from "./AgriCloudStackFeatures";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import { Row, Col } from "react-bootstrap";
export default function AgriCloudStackComponent() {
  return (
    <>
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle={["AgriCloud Stack"]}
        bannerbodycopy="Drive digital connectivity and Insights at the edge
        "
      />

      <SolutionEcosystem title="Overview" type="AgriCloudStack" />
      <Container>
        <Row>
          <Col md={6}>
            <ul>
              <li>
                Security Gateway : To provide secure communication channel
              </li>
              <li>
                SEP (Service End Point) : To integrate with third party
                applications/ cloud apps
              </li>
              <li>
                DEP (Service End Point) : To integrate with third party
                devices/assets
              </li>
              <li>
                AEP (Application End Point) : Provide APIs for third party farm
                solution developer
              </li>
            </ul>
          </Col>
          <Col md={6}>
            <ul>
              <li>
                Device Management : To manage devices from third party device
                OEM's
              </li>
              <li>
                Device Hub : Enables integration and interoperability with third
                party hardware and software
              </li>
              <li>
                Data Hub : It act as Farm Management Information System (FMIS)
                to store data from different farms of differenr agribusiness{" "}
              </li>
              {/* <li>
                        AEP (Application End Point) : Provide APIs for third party farm solution developer
                    </li> */}
            </ul>
          </Col>
        </Row>
      </Container>
      <AgriCloudStackFeatures />

      <AgriCloudStackBenefits />
    </>
  );
}
